import React from "react";
import { UseFormReturn } from "react-hook-form";
import { ClienteFormValues } from "../ClienteFormSchema";
import { FormattedTextField } from "@/components/form/FormattedTextField";
import { SelectField } from "@/components/form/SelectField";
import {
  PipelineFormSection,
  pipelineFieldGridClassCompact,
  usePipelineForm,
} from "@/components/form/PipelineFormContext";

interface BankInfoStepProps {
  form: UseFormReturn<ClienteFormValues>;
}

const tipoContaOptions = [
  { value: "corrente", label: "Conta Corrente" },
  { value: "poupanca", label: "Conta Poupança" },
  { value: "salario", label: "Conta Salário" },
];

export function BankInfoStep({ form }: BankInfoStepProps) {
  const { isPipeline } = usePipelineForm();

  return (
    <PipelineFormSection>
      <div className={pipelineFieldGridClassCompact(isPipeline)}>
        <SelectField
          form={form}
          name="tipoConta"
          label="Tipo de Conta"
          options={tipoContaOptions}
          placeholder="Selecione"
        />

        <FormattedTextField
          form={form}
          name="banco"
          label="Banco"
          formatter="texto"
          placeholder="Nome do banco"
        />

        <FormattedTextField
          form={form}
          name="agencia"
          label="Agência"
          formatter="texto"
          placeholder="0000"
        />

        <FormattedTextField
          form={form}
          name="conta"
          label="Conta"
          formatter="texto"
          placeholder="00000-0"
        />
      </div>
    </PipelineFormSection>
  );
}
